import React from "react";
import { useLocation, useParams } from "react-router-dom";

// components
import Loading from "../../components/Loadings/LoadingTable";
import FactorParent from "./FactorParent";

// styled components
import { Tr } from "./factorStyle";
import { useGetFinalPrint } from "../../hooks/useAccounting";
import { separate } from "../../utils/separate";

const Factor = () => {
  const { id } = useParams();
  const location = useLocation();
  const locationSearch = location?.search?.split("=");
  const isFactor = locationSearch[1];

  const { data, isLoading } = useGetFinalPrint(
    {
      IdEquivalentOrderOffline: id,
    },
    isFactor
  );

  const PreInvoice = data?.data?.PreInvoice[0];
  const UserSubmitted = data?.data?.UserSubmitted[0];
  const addresses = data?.data?.addresses[0];
  const list_order_offlines = data?.data?.list_order_offlines;
  const factor_status_payments = data?.data?.factor_status_payments[0];
  const PriceDebt = data?.data?.PriceDebt;
  if (isLoading) {
    return <Loading />;
  }

  return (
    <>
      <FactorParent
        PreInvoice={PreInvoice}
        UserSubmitted={UserSubmitted}
        addresses={addresses}
        list_order_offlines={list_order_offlines}
        PriceDebt={PriceDebt}
        factor_status_payments={factor_status_payments}
      >
        {list_order_offlines?.map((item, index) => {
          return (
            <Tr key={index}>
              <td style={{ width: "10px" }}>{index + 1}</td>
              <td>{item?.IdProducts}</td>
              <td>{item?.NameProducts}</td>
              <td>{item?.NumberSeller}</td>
              <td>{item?.NumberInJeansOrder > 1 ? "جین" : "عدد"}</td>
              <td>{separate(item?.GeneralPriceProductsOrder)}</td>
              <td>
                {separate(item?.GeneralPriceProductsOrder * item?.NumberSeller)}
              </td>
              {item?.Discount > 0 ? (
                <>
                  <td>{item?.Discount}%</td>
                  <td>{separate(PreInvoice?.PriceAll)}</td>
                </>
              ) : (
                <>
                  <td></td>
                  <td></td>
                </>
              )}
            </Tr>
          );
        })}
      </FactorParent>
    </>
  );
};
export default Factor;
